import { Container, Paper } from '@mui/material';
import { PropsWithChildren, useMemo } from 'react';
import { Footer, Header, NavDrawer, NavLinkButton } from 'shared/components';
import { useCategories } from 'shared/queries';
import { useAppState } from 'shared/stores';

export function AuthLayout({ children }: PropsWithChildren<{}>) {
    const appState = useAppState();
    const { categories, isLoading } = useCategories();

    const open = appState.sideDrawerOpen.get();

    const toggle = () => {
        appState.sideDrawerOpen.set(prev => !prev);
    };

    const navButtons: NavLinkButton[] = useMemo(
        () => [
            { text: 'Products', path: '/products' },
            {
                text: 'Model Parameters:',
                path: '',
                children: (categories || []).map(({ name, key }) => ({ text: name, path: `/parameters/${key}` })),
            },
        ],
        [categories]
    );
    return (
        <>
            <Header />
            <NavDrawer open={open} toggle={toggle} buttons={navButtons} loading={isLoading}>
                <Container sx={{ marginTop: 2 }} maxWidth={false}>
                    <Paper>{children}</Paper>
                </Container>
            </NavDrawer>
            <Footer />
        </>
    );
}
